
import {  Users } from "lucide-react";
import Link from "next/link";
import { MdOutlinePets } from "react-icons/md";

const CommunityBanner = () => {
  return (
    <div className="bg-indigo-300/40 rounded-[20px] py-4 px-8 flex flex-col xl:flex-row xl:items-center items-start justify-between gap-2">
      <div className="flex flex-col xl:flex-row xl:items-center items-start gap-3 xl:gap-6">
        <div className="bg-white rounded-full p-3">
          <Users className="w-6 h-6 text-[#6C5CE7]" />
        </div>
        <div className="flex flex-col gap-1">
          <h2 className="text-white text-2xl font-semibold">
            Join the Purr-fect Community!
          </h2>
          <p className="text-white/90">
            Don't miss your chance to be part of the most adorable revolution in
            crypto. Vote daily and earn rewards!
          </p>
        </div>
      </div>
      {/* <Button 
        variant="secondary" 
        className="bg-white hover:bg-white/90 text-[#6C5CE7] font-medium px-6 rounded-full"
      >
        Join the #HorizonUI Community!
      </Button> */}

      <Link href="/vote#votelist" className="">
        <div className="hover:brightness-110 flex justify-center items-center gap-3 w-fit font-bold py-3 px-4 rounded-full bg-white shadow-lg hover:shadow-indigo-800 text-indigo-600/80 text-xs md:text-sm text-nowrap">
          Vote Meow!
          <MdOutlinePets size={19} />
        </div>
      </Link>
    </div>
  );
};

export default CommunityBanner;
